import clsx from 'clsx';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from '../EventHeader.css';

export const EventHeaderMyEntityToggleItem = ({
  selected,
  contentId,
  onClick,
}: {
  selected?: boolean;
  contentId: ContentId;
  onClick: () => void;
}) => {
  return (
    <Stack
      className={clsx(styles.myEntityToggleItem, {
        [styles.myEntityToggleItemSelected]: selected,
      })}
      onClick={onClick}
    >
      <Content id={contentId} />
    </Stack>
  );
};
